import { safeRedirectPath } from '../utils/redirect';

export const resolveRedirectPath = (search: string, fallback = '/dashboard'): string => {
  const redirect = new URLSearchParams(search).get('redirect');
  const resolvedPath = safeRedirectPath(redirect, fallback);

  if (import.meta.env.DEV && redirect && redirect.trim() !== resolvedPath) {
    console.warn(
      `[authRedirect] Unsafe redirect discarded: "${redirect}" -> fallback "${resolvedPath}"`,
    );
  }

  return resolvedPath;
};

export const buildLoginRedirectPath = (
  pathname: string,
  search = '',
  hash = '',
): string => {
  const target = safeRedirectPath(`${pathname}${search}${hash}`, '/');
  return `/login?redirect=${encodeURIComponent(target)}`;
};
